import * as React from 'react';
import Auftraege from './Auftraege';

export default class AuftragUebersichtLizenz extends React.Component<{}, {}> {
  render() {
    return (
      <div>
        <h2>
          Aufträge meiner Lizenz
        </h2>
        <Auftraege lizenzAuftraege={true}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/auftraege/AuftragUebersichtLizenz.tsx